<template>
  <ul class="m-0 p-0 list-none flex flex-col gap-2">
    <slot />
  </ul>
</template>
